// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3P5E-","file":"styles_file__1EJq4"};